import { cva, type VariantProps } from 'class-variance-authority';
import { forwardRef, type HTMLAttributes } from 'react';
import { cn } from '../cn';

const badgeStyles = cva(
  'inline-flex items-center gap-1 rounded-xs px-2 py-0.5 text-xs font-medium tabular-nums whitespace-nowrap',
  {
    variants: {
      variant: {
        neutral: 'bg-surface-elev text-fg-secondary border border-border-subtle',
        accent: 'bg-accent/[0.12] text-accent-fg',
        positive: 'bg-positive/[0.12] text-positive',
        warning: 'bg-warning/[0.12] text-warning',
        negative: 'bg-negative/[0.12] text-negative',
        info: 'bg-info/[0.12] text-info',
      },
    },
    defaultVariants: {
      variant: 'neutral',
    },
  }
);

interface BadgeProps extends HTMLAttributes<HTMLSpanElement>, VariantProps<typeof badgeStyles> {}

export const Badge = forwardRef<HTMLSpanElement, BadgeProps>(
  ({ className, variant, ...props }, ref) => (
    <span ref={ref} className={cn(badgeStyles({ variant }), className)} {...props} />
  )
);
Badge.displayName = 'Badge';
